export default __webpack_public_path__ + "static/media/js.8aa1422b.svg";